// ./initAuth.js
import { firebaseConfig } from './firebase';
import { initializeApp, getApps } from 'firebase/app';
import {
  Auth,
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from 'firebase/auth';

const config = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  databaseURL: firebaseConfig.databaseURL,
  projectId: firebaseConfig.projectId,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// Initialize Firebase
let firebase_app =
  getApps().length === 0 ? initializeApp(config) : getApps()[0];

// The one Auth instance; import this instead of calling getAuth().
// In the browser getAuth() also installs the popup/redirect sign-in helper,
// which on mobile loads Firebase's auth iframe and Google's API loader on
// every page. Sign-in here is email, anonymous or custom token only, so the
// browser instance is created without it. Persistence is getAuth()'s default,
// so existing sessions are kept. If popup or redirect sign-in is ever added,
// pass browserPopupRedirectResolver to that call.

// The browser path never calls getAuth(): referencing it would bundle the
// popup/redirect helper this avoids. The server keeps getAuth() (Node build).
// The instance is kept on globalThis because the dev server re-runs this module
// on hot reload, and a second initializeAuth() on the same app throws.
const globalForAuth = globalThis as typeof globalThis & { __tipptourAuth?: Auth };

const createAuth = (): Auth => {
  if (typeof window === 'undefined') return getAuth(firebase_app);
  globalForAuth.__tipptourAuth ??= initializeAuth(firebase_app, {
    persistence: [
      indexedDBLocalPersistence,
      browserLocalPersistence,
      browserSessionPersistence,
    ],
  });
  return globalForAuth.__tipptourAuth;
};

export const auth = createAuth();

export default firebase_app;
